import React, { useEffect, useRef } from 'react'
import {Link, useLocation, useParams} from 'react-router-dom';
import NotFoundPage from './NotFoundPage';
import { isMobile } from 'react-device-detect';
import html2canvas from 'html2canvas';


export default function Certificate(props) {
    const {certificateList} = props;
    const location = useLocation();
    const param = useParams();
    var certificateId = param.id;
    const path = process.env.REACT_APP_STATIC_CDN_ASSETS_IUIU;
    const targetRef = useRef(null);
    const handleDownloadScreenshot = () => {
        // Ensure the ref is attached to an element
        if (!targetRef.current) {
            console.error("Target element not found.");
            return;
        }

        // 2. Pass the DOM element reference to html2canvas
        html2canvas(targetRef.current, {
            scale: 10, 
            useCORS: true 
        }).then(canvas => {
            
            // 3. Convert canvas to URL and trigger download
            const imageURL = canvas.toDataURL('image/png');
            const a = document.createElement('a');
            
            a.href = imageURL;
            a.download = certificateList.filter(c=>c.id===certificateId)[0].title+"-"+new Date();
            
            // Trigger the download
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            
        }).catch(error => {
            console.error("Error generating screenshot:", error);
        });
    };
    useEffect(()=>{
    }, [certificateList])
    return (
        <div className=''>
            {certificateList && certificateList?.length>0 ? (<div ref={targetRef}  className="row top certificate" style={{padding: "1rem", background: "white", fontSize: "1rem", border: "solid orange 1rem"}}>
                <div className="row center" style={{color: "black", backdropFilter: "blur(36rem) brightness(100%)"}}>
                    <div className='col'>
                        <div className="row" style={{marginBottom: "1rem"}}>
                            <div className='row left' style={{width: "50%"}}>
                                <div><img className='orgLogo' src={path+"/"+certificateList.filter(c=>c.id===certificateId)[0].organization1.logo}></img></div>
                                <div className='row'>{certificateList.filter(c=>c.id===certificateId)[0]?.organization1?.name}</div>
                            </div>
                            <div className='row right' style={{width: "50%"}}>
                                <div><img className='orgLogo' src={path+"/"+certificateList.filter(c=>c.id===certificateId)[0].organization2.logo}></img></div>
                                <div className='row'>{certificateList.filter(c=>c.id===certificateId)[0]?.organization2?.name}</div>
                            </div>
                        </div>
                        <div className='row center' style={{fontSize: '2rem'}}>
                            <b>{certificateList.filter(c=>c.id===certificateId)[0]?.title}</b>
                        </div>
                        <div className='row left'>
                            
                            {!isMobile && <div className='row center' style={{width: "45vw"}}>
                                    <div className='col' style={{fontSize: "2rem"}}>
                                    {certificateList.filter(c=>c.id===certificateId)[0].content.split("\n").map((d)=>
                                    <p>
                                        {<><b>{d.split(":")[0]}:</b> <>{d.split(":")[1]}</></>}
                                    </p>)}
                                </div>
                            </div>}
                            {isMobile && <div className='row center' style={{width: "45vw"}}>
                                    <div className='col'>
                                    {certificateList.filter(c=>c.id===certificateId)[0].content.split("\n").map((d)=>
                                    <p>
                                        {<><b>{d.split(":")[0]}:</b> <>{d.split(":")[1]}</></>}
                                    </p>)}
                                </div>
                            </div>}
                            <div className='row center' style={{top: "0", width: "45vw"}}>
                                <div alt='Miss Chowcolate' className='idPhoto' style={{backgroundImage: `url(${path}/${certificateList.filter(c=>c.id===certificateId)[0].photo})`}}></div>
                                <div className='stamp' style={{backgroundImage: `url(${path}/${certificateList.filter(c=>c.id===certificateId)[0].signed.stamp})`}}></div>
                            </div>
                            
                        </div>
                        <div className='row right'>
                            {certificateList.filter(c=>c.id===certificateId)[0].signed.location}, {certificateList.filter(c=>c.id===certificateId)[0].signed.date}
                        </div>
                        <div className='row right'>
                            {certificateList.filter(c=>c.id===certificateId)[0].signed.role}
                        </div>
                        <div className='row right'>
                            {certificateList.filter(c=>c.id===certificateId)[0].signed.name}
                        </div>
                        <div className='row right'>
                            <img style={{width: "10rem"}} src={path+"/"+certificateList.filter(c=>c.id===certificateId)[0].signed.signature}/>
                        </div>
                        
                    </div>
                    
                </div>
                <div className='iuiuButton row center' 
                    onClick={handleDownloadScreenshot}
                    style={{ marginTop: '15px', padding: '10px 20px', cursor: 'pointer' }}
                >
                    <i class="fa fa-download" aria-hidden="true"></i>
                </div>
            </div>): <NotFoundPage/> }
            <div className="row center">
                 <Link to='/'>Back to Homepage</Link>   
            </div>
        </div>
    )
}
